import React, { useContext, useEffect, useState } from 'react'
import Intro from './Intro'
import Professional from './Professional'
import PropertyOwner from './PropertyOwner'
import Agreement from './Agreement'
import Header from './Header'
import {ReactComponent as Spinner} from '../assets/spinner.svg';
import { context } from '../App'
import OverlayVideo from './OverlayVideo'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function Home({readyToSubmit}) {
    const {
        slideCount,
        showAgreement,
        setShowAgreement,
        setSlideCount,
        resetStates,
        agreeEnabled,
        setAgreeEnabled,
        isPlayClicked
    } = useContext(context);
    
    const {token, payload} = useContext(context);
    
    const { contactId } = useParams()
    const [isValidContactId, setIsValidContactId] = useState(false)
    const [isAgreementContactId, setIsAgreementContactId] = useState(false)
    const [inviteId, setInviteId] = useState("")

    // console.log(contactId)
    // console.log(slideCount)

    useEffect(()=> {
        let pathName = window.location.pathname
        let isNumberContains = /\d/.test(pathName)
        if(contactId && isNumberContains){
        fetch("https://api.proinsight.com/deepdive_contact", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization" : token
            },
            body: JSON.stringify({"contactId": contactId})
        })
        .then(resp => {
            if(resp.ok){
                // toast.success("Agreement sent to email");
                // setIsLoading(false);
                setIsValidContactId(true)
                // setSlideCount(3)
                // setAgreeEnabled(true);
            }
            else{
                toast.error("Contact Not Found");
                // setIsLoading(false);
                setIsValidContactId(false)
            }
        })
        .catch(err => {
            toast.error("Something went wrong");
            // setIsLoading(false);
        })            
        }else if(contactId){
            console.log(contactId);
            // setSlideCount(0)
            setIsValidContactId(false)
            setInviteId(contactId)
        }
    },[])

    return (
        <>
            <Header />
            {
                ((slideCount === 0 ) && ((!isValidContactId && inviteId) || !contactId) )
            &&
                <Intro />
            }

            {
                ((slideCount > 0 && slideCount < 11) || isValidContactId)
            &&
                <Professional readyToSubmit={readyToSubmit} isValidContactId={isValidContactId} setIsValidContactId={setIsValidContactId} setIsAgreementContactId={setIsAgreementContactId} isAgreementContactId={isAgreementContactId} contactId={contactId} />
            }
            
            {
                (slideCount >= 11  )
            &&
                <PropertyOwner readyToSubmit={readyToSubmit} />
            }

            {
                (showAgreement && (slideCount === 5 || slideCount === 13))
            &&
                <Agreement setShowAgreement={setShowAgreement} resetStates={resetStates} agreeEnabled={agreeEnabled} setAgreeEnabled={setAgreeEnabled} contactId={contactId} isAgreementContactId={isAgreementContactId} />
            }

            {
                isPlayClicked
                &&
                <OverlayVideo />
            }

            {
                (slideCount === 6 || slideCount === 14)
            &&
                <div className="redirecting" style={{color: "white"}} >
                    { (window.location.href.includes("propertyowner.proinsight") || window.location.href.includes("pay.proinsight") || window.location.href.includes("get.proinsight") || window.location.href.includes("nbp.proinsight")) ? <div  >
                        <h1 className="redirecting">You’re all set!</h1>
                        <h1 className="redirecting"> We are excited to help you reach your goals.</h1>
                    </div>  : window.location.href.includes("apply.proinsight") ? <div style={{width: "80vw"}} >
                        <img style={{width: "300px", marginBottom: "3rem"}}  src='https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6880e057e69c95175b1aef66.png' />
                        <h1 >Thank you for applying for membership in your local Homeowner Concierge™ Community.</h1>
                        <h1 style={{ marginTop: "3rem"}} >Applications are reviewed carefully and territories are awarded selectively. Based on your responses and a conversation with one of our Ambassadors, we’ll determine whether you’re the right fit to secure the exclusive territory in your region.</h1>
                        <h1 style={{ marginTop: "3rem"}} >We look forward to being in touch.</h1>
                    </div> : <div>
                        <Spinner className='redirecting-loader' stroke='#fff' width="50px" height="50px" />
                        <h1 className="redirecting">Don't close the tab, Redirecting...</h1>
                    </div>}

                </div>
            }

            {
                (slideCount === 15)
            &&
                <div className="redirecting">
                    <div>
                        <h1 className="redirecting">Your application has been received and your membership is pending.</h1>
                        <h1 className="redirecting">We will reach out to talk through next steps.</h1>
                    </div>
                </div>
            }
        </>
    )
}